import { NoTzDate } from "../../DateUtils"

export enum PayeeType {
    Payer = 0,
    Patient = 1
} 
export enum CaptureMethod {
    ExistingCard = "E",
    ManualEntry = "M",
    Swipe = "S"
};
export enum SubmssionType {
    PaymentOnly = 1,
    CardPayment = 2,
    CardOnly = 3
}
export enum DataDisplayLevel {
    GatherData = 1,
    DisplayReceipt = 2,
    CaptureMethod = 3,
    Completed = 4
};
export enum PaymentSourceDescription {
    MML = "MML",
    OfficeEMR = "OfficeEMR",
    Intake = "Intake",
    PmtPlan = "PmtPlan"
};
export interface IReceiptData {
    useReceipt: boolean,
    requirePayment: boolean,
    childCallback: boolean,
    paidByType?: PayeeType,
    paidByID?: number,
    paidByName?: string, 
    appointmentID?: number, 
    paidByEID?: number, 
    serviceLocationEID?: number, 
    paymentMethod?: number, 
    paymentType?: number, 
    receiptAmount?: number, 
    comment?: string,
    batch?: number,
    claimIndicator?: string,
    commentIndicator?: string,
    procedureIndicator?: string,
    diagnosisIndicator?: string,
    copayIndicator: boolean,
    paymentBatchID?: number,
    paymentBatchData?: string
    paymentPlanID?: number,
    paymentPlanData?: string
};
export interface IMerchantKeyInformation {
    validMerchantId: boolean, 
    paySimpleMerchantKey: string,
    paymentBatchRequired: boolean
};
export interface IPatientCreditCard {
    paymentMethodId: number,
    paySimpleToken: string,
    cardInformation: string,
    duplicateCount: number,
    paymentPlans: string
};
export interface IPatientCreditCardRemovals {
    paymentMethodId: number,
    cardInformation: string,
    description: string,
    disabled: boolean,
    removalFlag: boolean,
    removalMessage: string,
    planMessage?: string,
    planCount: number
};
export interface IPaySimpleCardRequest {
    paySimpleToken: string,
    submssionType: SubmssionType,
    source: PaymentSourceDescription,
    receiptData: IReceiptData 
};
export interface IPaySimpleCardInactivate {
    paymentMethodId: number
};
export interface IPaySimpleSubmission {
    errorCode: boolean,
    errorMessage: string,
    paymentMethodId?: number,
    paymentAmount?: number,
    paymentMessage?: string,
    redirectURL?: string
};
export interface IPaySimple3DS {
    transactionID: string, 
    activityID: number, 
    receiptData: IReceiptData 
};

export interface ICreditCardData {
    cardType: string,
    lastFour: string,
    expirationDate: NoTzDate,
    dateAdded?: NoTzDate,
    dateInactivated?: NoTzDate
};